module.exports = __webpack_public_path__ + "img/credit-one-club-gal-15.9e8e08f3.jpg";